export const EventsName = {
  TOGGLE_LIVE_MODAL: 'toggle_live_modal',
  COMMUNITY_GROUP_MODAL: 'community_group_modal',
  COMMUNITY_CONFIGURATION_SIDEBAR: 'community_configuration_sidebar',
  BIND_EXCLUSIVE_COMMUNITY_SURVEY: 'bind_exclusive_community_survey',
  DELETE_MODAL: 'delete_modal',
  DELETE_MODAL_OLD: 'delete_modal_old',
  INVALIDATE_COMMUNITY_QUERY: 'invalidate_community_query',
  RESET_FORM_GENERAL_CONFIG: 'reset_form_general_config',
  INVALIDATE_FOLLOWERS_ROLES_QUERY: 'invalidate_followers_roles_query',
  INVALIDATE_GROUP_COMMUNITIES_QUERY: 'invalidate_group_communities_query',
  LOGOUT: 'logout',
  LOGIN: 'login',
  MODAL: 'modal',
  OPEN_MEMBERS_IMPORT: 'open_members_import',
  FREE_SIGNUP: 'free_signup',
  REFRESH_THEME: 'refresh_theme',
  RENEW: 'renew_token',
  TOAST: 'toasted',
  UNBAN_MEMBER_COMMUNITY: 'unban_member_community_modal',
  REMOVE_USER_NO_ACCESS_ROLE: 'remove_user_no_access_role',
  RESET_VIEW_AS_ROLES: 'reset_view_as_roles',
  INVALIDATE_ONBOARDING_QUERY: 'invalidate_onboarding_query',
  PRODUCT_FRUITS_USER: 'product_fruits_user',
  TOGGLE_CONCLUSION_MODAL: 'toggle_conclusion_modal',
  OPEN_GAMIFICATION: 'open_gamification'
}
